var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paging"},[_c('el-pagination',{attrs:{"background":"","hide-on-single-page":_vm.show,"next-text":"下一页","prev-text":"上一页","current-page":_vm.currentPage,"page-size":_vm.pageSize,"layout":"prev, pager, next, jumper, total","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }